import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: "https://415c67ca74ac338dd8917e2fddc666c8@o4510836771323904.ingest.us.sentry.io/4510910526914560",
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
});
